import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import {
  leaseAgreementCommand,
  LeaseAgreementFilteredCommand,
  LeaseAgreementMultiselectCommand,
} from '../../command/lease-agreement.command';
import { DwellingContractService } from '../data/dwelling-contract.service';
import { ParkingContractService } from '../data/parking-contract.service';
import { PremisesContractService } from '../data/premises-contract.service';
import { OtherContractService } from '../data/other-contract.service';
import { BlockContractService } from '../data/block-contract.service';
import { CooperativeHousingContractService } from '../data/cooperative-housing-contract.service';
import { LeaseAgreementCommandHandlerBase } from '../../../message/service/command/lease-agreement-command-handler.base';
import { LeaseAgreementListService } from '../data/lease-agreement-list.service';
import { LeaseAgreementCategory } from '../../model/const/enums';

@Injectable()
export class LeaseAgreementExportCommandHandler extends LeaseAgreementCommandHandlerBase implements ICommandHandler {
  constructor(
    dwellingService: DwellingContractService,
    parkingService: ParkingContractService,
    premisesService: PremisesContractService,
    otherService: OtherContractService,
    blockService: BlockContractService,
    cooperativeService: CooperativeHousingContractService,
    private readonly _nativeWindow: NativeWindowService
  ) {
    super(dwellingService, parkingService, premisesService, otherService, blockService, cooperativeService);
  }

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === leaseAgreementCommand.export && command.itemsSource.length > 0;
    }
    if (command instanceof FilteredCommand) {
      return command.id === leaseAgreementCommand.export && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      let categoryCommand = command as LeaseAgreementMultiselectCommand;
      return this._getService(categoryCommand.category)
        .export(command.items.map(item => item.id))
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
    if (command instanceof FilteredCommand) {
      let categoryCommand = command as LeaseAgreementFilteredCommand;
      const categoryService = this._getService(categoryCommand.category);
      const exportDataService = categoryCommand.category === LeaseAgreementCategory.CooperativeHousing
        ? categoryService
        : command.dataService ?? categoryService;
      const exportRequest: Observable<File> = exportDataService instanceof LeaseAgreementListService
        ? exportDataService.exportFiltered(
            command.filterProvider.filterState,
            command.includedIds,
            command.excludedIds,
            command.totalAffectedItemsControlValue,
            categoryService.exportFilename
          )
        : exportDataService.exportFiltered(
            command.filterProvider.filterState,
            command.includedIds,
            command.excludedIds,
            command.totalAffectedItemsControlValue
          );

      return exportRequest
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
